export var ViewMode = {
  Hidden: 'Hidden',
  Visible: 'Visible'
};
export var CallOperatorState = {
  /**
   * Call is inactive and we are not connected.
   */
  Inactive: 'Inactive',
  /**
   * Call is incoming, waiting for a response. There can be multiple incoming
   * calls at once, although that is highly unlikely.
   */
  Incoming: 'Incoming',
  /**
   * Call is being joined. Set to this before connecting.
   */
  Connecting: 'Connecting',
  /**
   * Call is currently active. When a call is active, it must be hung up
   * before an incoming call can be accepted.
   */
  Connected: 'Connected'
};
//# sourceMappingURL=constants.js.map
